import { ComponentProps } from "react";
import {
  IInputContainerProps,
  InputContainer,
} from "../InputContainer/inputContainer";

type IInputTextProps = ComponentProps<"input"> & IInputContainerProps;
export const InputText = ({ label, ...rest }: IInputTextProps) => {
  return (
    <InputContainer label={label} required={rest.required}>
      <input {...rest} />
    </InputContainer>
  );
};
